import React, { Component } from 'react'
import PropTypes from 'prop-types'
import LinearProgress from '@material-ui/core/LinearProgress'

import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import FormHelperText from '@material-ui/core/FormHelperText'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'

import { Colors } from '../theme'

class RBSelectField extends Component {
  constructor (props) {
    super(props)
    this.handleChange = this.handleChange.bind(this)
    this.resetState = this.resetState.bind(this)
    let defaultValue = { id: 0, text: props.defaultText }
    this.state = {
      value: defaultValue || 0
    }
    // save a copy
    this.baseState = { value: { id: 0, text: props.defaultText } }
  }

  handleChange (event, index, value) {
    const obj = { id: index.key, text: index.props.value }

    this.setState({
      value: obj
    })
    if (this.props.sendValues) {
      this.props.sendValues({ [this.props.id]: index.props.value, textValue: index.props.children })
    }
    if (this.props.onChanged) {
      this.props.onChanged({
        id: this.props.id,
        value: index.props.value,
        text: index.props.children
      })
    }
  }

  resetState () {
    const self = this
    this.setState({ ...self.baseState })
  }

  render () {
    const props = this.props
    const data = props.data
    const defaultText = props.defaultText || null
    const val = props.selected || this.state.value
    return (
      <FormControl style={{ width: props.fullWidth ? '100%' : 'auto' }}>
        <InputLabel
          htmlFor={props.id}
          error={!!props.errorText}
          style={{
            color: Colors.Palette.primaryTextColor
          }}
        >{props.label}</InputLabel>
        <Select
          value={typeof val === 'object' ? val.id : val}
          onChange={this.handleChange}
          ref={(input) => { this.select = input }}
          style={{ width: props.fullWidth ? '100%' : 'auto' }}
          error={!!props.errorText}
        >
          {defaultText && <MenuItem key={0} value={0}>{defaultText}</MenuItem>}
          {data && data.map((item, i) => {
            if (item.text) {
              return <MenuItem key={i + 1} value={item && item.id}>{item && item.text}</MenuItem>
            } else {
              return <MenuItem key={i + 1} value={item}>{item}</MenuItem>
            }
          })}

        </Select>
        {this.props.loading
          ? <LinearProgress color='primary' style={{ position: 'relative', bottom: 23 }} />
          : null}
        <FormHelperText error={!!props.errorText}>{props.errorText}</FormHelperText>
      </FormControl>
    )
  }
}

RBSelectField.propTypes = {
  data: PropTypes.array,
  defaultText: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  label: PropTypes.string,
  // send values only sends back the id and the value as an object defined as follows {[this.props.id]: value}
  sendValues: PropTypes.func,
  // onChanged sends extra details which are id, value (which is the dropdown value), and text (which is the text displayed to the user). Object is as follows
  // {id, value, text}
  onChanged: PropTypes.func
}

export default RBSelectField



// WEBPACK FOOTER //
// ./src/controls/RBSelectField.js